import { render, staticRenderFns } from "./ChatOrderCoupon.vue?vue&type=template&id=3738d71e&scoped=true&"
import script from "./ChatOrderCoupon.vue?vue&type=script&lang=js&"
export * from "./ChatOrderCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderCoupon.vue?vue&type=style&index=0&id=3738d71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738d71e",
  null
  
)

export default component.exports